(function(){
  function init(){
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    var hWrap = document.getElementById('ar2-hscrollWrap');
    var hTrack = document.getElementById('ar2-hscrollTrack');
    var hPin = hWrap ? hWrap.querySelector('.ar2-hscroll-pin') : null;
    var hDots = hWrap ? hWrap.querySelectorAll('.ar2-hscroll-progress span') : [];
    if (hWrap && hTrack && hPin) {
      // Pin nativo de GSAP (no CSS position:sticky): el sitio tiene overflow-x:hidden
      // en html/body para evitar scroll horizontal en movil, y eso rompe position:sticky.
      gsap.to(hTrack, {
        x: function(){ return -(hTrack.scrollWidth - window.innerWidth); },
        ease: 'none',
        scrollTrigger: {
          trigger: hWrap, start: 'top top', end: 'bottom bottom', scrub: 0.7, invalidateOnRefresh: true,
          pin: hPin, anticipatePin: 1,
          onUpdate: function(self){
            var idx = Math.min(hDots.length - 1, Math.floor(self.progress * hDots.length));
            hDots.forEach(function(el, i){ el.classList.toggle('is-active', i === idx); });
          }
        }
      });
    }

    var parallaxSection = document.querySelector('.ar2-parallax');
    var parallaxImg = document.getElementById('ar2-parallaxImg');
    if (parallaxSection && parallaxImg) {
      gsap.fromTo(parallaxImg, { scale: 1, yPercent: -4 }, {
        scale: 1.18, yPercent: 4, ease: 'none',
        scrollTrigger: { trigger: parallaxSection, start: 'top bottom', end: 'bottom top', scrub: 0.8 }
      });
    }
    if (parallaxSection) {
      var title = parallaxSection.querySelector('.ar2-parallax__fg h2');
      var sub = parallaxSection.querySelector('.ar2-parallax__fg p');
      if (title) {
        var tl = gsap.timeline({ scrollTrigger: { trigger: parallaxSection, start: 'top 65%' } });
        tl.to(title.querySelectorAll('.ar2-word'), { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.9, ease: 'power3.out', stagger: 0.09 });
        if (sub) tl.to(sub, { opacity: 1, duration: 0.7, ease: 'power2.out' }, '-=0.3');
      }
    }

    document.querySelectorAll('.ar2-demo-big__item, .ar2-demo-big__solo').forEach(function(el, i){
      gsap.to(el, {
        opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', delay: i * 0.15,
        scrollTrigger: { trigger: el, start: 'top 85%' }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
